__webpack_require__.p = "/delete-confirm-dialog/referrals-hub/";